<footer class="footer">
  <div class="footer-wrapper">
    <a href="https://www.newvisions.org">
      <div class="footer-logo"><nv-logo type="wordmark"></nv-logo></div>
    </a>

    <div *ngFor="let section of content" class="footer-section">
      <h3>{{section.title}}</h3>
      <ng-container *ngFor="let link of section.links">
        <button
          *ngIf="link.type == 'button'; else anchorTag"
          class="footer-link" 
          (click)="linkActionFromId(link.id)"
        >{{link.label}}</button>

        <ng-template #anchorTag>
          <a 
            class="footer-link" 
            [href]="link.url" 
            [target]="link.type == 'tab' ? '_blank' : ''"
          >
            {{link.label}}
            <nv-icon *ngIf="link.type == 'tab'"  name="external"></nv-icon>
          </a>
        </ng-template>
      </ng-container>
    </div>
  </div>
</footer>